import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InstallationDetailsStore, InstallationPanelOrder } from '../../../@store';

@Injectable({
  providedIn: 'root',
})
export class DragDropLayoutService {
  // used for rearranging panels on mobile
  renderedPanels: { [key: string]: string[] } = {};

  isDragDropDisabled = new BehaviorSubject(false);

  constructor(private installationDetailsStore: InstallationDetailsStore) {}

  updatePanelOrderListAfterDrop(
    previousContainerData: string,
    currentConteinerData: string,
    panels: InstallationPanelOrder[],
    deviceId: string
  ): void {
    const prevTile = panels.map((panel) => panel.panel).indexOf(previousContainerData);
    const targetTile = panels.map((panel) => panel.panel).indexOf(currentConteinerData);

    moveItemInArray(panels, prevTile, targetTile);
    this.installationDetailsStore.savePanelsOrder(deviceId, [].concat(panels));
  }
}
